import React, { forwardRef } from 'react';
import { brandLogo } from '@retail/utils';
import { Brand } from '@retail/auth/types';
import { Image } from '../Image';
import { BoxProps } from '@mui/material';

export type BrandLogoSize = 'small' | 'medium' | 'large';

interface Props extends BoxProps {
  brand: Brand;
  size?: BrandLogoSize;
}

export const BrandLogo = forwardRef<HTMLImageElement, Props>(
  ({ brand, size = 'medium', ...rest }, ref) => (
    <Image
      {...rest}
      ref={ref}
      src={brandLogo(brand.brandId).logo}
      alt={brand.name}
      height={brandLogoSizeMap[size]}
      width={brandLogoSizeMap[size]}
    />
  )
);

export const brandLogoSizeMap: Record<BrandLogoSize, number> = { small: 20, medium: 30, large: 40 };
